module.exports = __webpack_public_path__ + "static/media/crypto_analysis.f4f71f82.jpg";